import { render, staticRenderFns } from "./MsgElementArticle.vue?vue&type=template&id=33aacd9d&scoped=true"
import script from "./MsgElementArticle.vue?vue&type=script&lang=js"
export * from "./MsgElementArticle.vue?vue&type=script&lang=js"
import style0 from "./MsgElementArticle.vue?vue&type=style&index=0&id=33aacd9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aacd9d",
  null
  
)

export default component.exports